/**
 * The Static Texts used in this application.
 */
class Texts {


    // ########################### HTTP SPECIFIC API RESPONSE ###################################

    /**
     * When the given request is incomplete or wrong in the context of the server call
     */
    static readonly badRequest: string = "There seems to be a problem with your request. please contact technical support";
    /**
     * When the user should log in to access the data from the server.
     */
    static readonly unauthorized: string = 'Please Login / Signup to use this feature.';
    /**
     * When the user does not have access to the requested data.
     */
    static readonly forbiddenAccess: string = 'You do not have access to the requested information. please contact technical support.';
    /**
     * When server was not found to communicate with
     */
    static readonly notFound: string = 'The requested endpoint does not exist. please contact technical support.';
    /**
     * When server instance for the api call crashed or was terminated before any response could be given
     */
    static readonly serverError: string = 'Can not communicate with the servers properly, please try again later.';

    // ########################### CUSTOM API RESPONSE ###################################

    /**
     * When the server call failed due to a problem in request preparation.
     */
    static readonly requestFailed: string = "There seems to be a problem with your request. please contact technical support.";
    /**
     * When the server call successfully was made but response was never returned.
     */
    static readonly serverNotResponded: string = 'Can not communicate with the servers properly, please try again later.';
    /**
     * When the server call failed due to entity not found. (Internal status code)
     */
    static readonly internalNotFound = "The requested entity was not found.";


    // ########################### FORM VALIDATION ###################################

    /**
     * The texts used in form validation.
     */
    static readonly FormValidation = class {

        /**
         * The text to show when a field is required.
         */
        static readonly requiredField: string = "This field is required.";

        /**
         * The text to show when a field is not a valid field.
         * @param field     The field name.
         */
        static readonly invalidField = (field: string) => `Value must be a valid ${field}.`;

        /**
         * The text to show when a field is not a valid email.
         */
        static readonly invalidEmail: string = this.invalidField("email");

        /**
         * The text to show when a field is not a valid phone number.
         */
        static readonly invalidPhoneNumber: string = this.invalidField("phone number");

        /**
         * The text to show when a field is not a valid URL.
         */
        static readonly invalidUrl: string = this.invalidField("URL");

        /**
         * The text to show when a field is not a valid number.
         */
        static readonly invalidNumber: string = this.invalidField("number");

        /**
         * The text to show when a field is not a valid date.
         */
        static readonly invalidDate: string = this.invalidField("date");

        /**
         * The text to show when a field is not a valid time.
         */
        static readonly invalidTime: string = this.invalidField("time");

        /**
         * The text to show when a field is not a valid date time.
         * @param date      The date format.
         */
        static readonly afterDate = (date: string) => `Value must be after ${date}`;

        /**
         * The text to show when a field is not a valid date time.
         * @param date      The date format.
         */
        static readonly beforeDate = (date: string) => `Value must be before ${date}`;

        /**
         * The text to show minimum length of the field.
         * @param length    The minimum length.
         */
        static readonly minLength = (length: number) => `Minimum ${length} characters long.`;

        /**
         * The text to show maximum length of the field.
         * @param length    The maximum length.
         */
        static readonly maxLength = (length: number) => `Maximum ${length} characters long.`;

        /**
         * The text to show minimum value of the field.
         * @param number    The minimum value.
         */
        static readonly minNumber = (number: number) => `Value must be at least ${number}.`;

        /**
         * The text to show positive number.
         * @param number    The minimum value.
         */
        static readonly positiveNumber = `Value must be positive.`;

        /**
         * The text to show maximum value of the field.
         * @param number    The maximum value.
         */
        static readonly maxNumber = (number: number) => `Value must be at most ${number}.`;

        /**
         * The text to show minimum array length.
         * @param length    The minimum length.
         */
        static readonly minArrayLength = (length: number) => `Value must have at least ${length} items.`;

        /**
         * The text to show maximum array length.
         * @param length    The maximum length.
         */
        static readonly maxArrayLength = (length: number) => `Value must have at most ${length} items.`;
    }
}

export default Texts;
